import * as React from 'react';
import { createUseAnnotationDoc } from './createUseAnnotationDoc';
export const useAnnotationDoc = createUseAnnotationDoc(React);
